import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import Tesseract from 'tesseract.js';

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

export const extractInvoiceNumber = async (file, onStatusChange) => {
  try {
    let fullText = '';
    
    if (onStatusChange) {
      onStatusChange(true);
    }

    if (file.type === 'application/pdf') {
      const arrayBuffer = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(new Uint8Array(reader.result));
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });

      const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
      const maxPages = Math.min(pdf.numPages, 2); 
      
      for (let i = 1; i <= maxPages; i++) {
        const page = await pdf.getPage(i);
        const textContent = await page.getTextContent();
        fullText += textContent.items.map(item => item.str).join(' ') + ' ';
      }

      if (!fullText.trim()) {
        
        for (let i = 1; i <= maxPages; i++) {
          const page = await pdf.getPage(i);
          const viewport = page.getViewport({ scale: 2.0 }); 
          
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          await page.render({ canvasContext: context, viewport: viewport }).promise;

          const dataUrl = canvas.toDataURL('image/png');
          const result = await Tesseract.recognize(dataUrl, 'eng');
          fullText += result.data.text + ' ';
        }
      }

    } else if (file.type.startsWith('image/')) {
      const result = await Tesseract.recognize(file, 'eng');
      fullText = result.data.text;
    }

    fullText = fullText.replace(/\s+/g, ' ');

    const regexes = [
      // 1. Matches exact "Tax Invoice - 1234/56" format
      /Tax\s+Invoice\s*-\s*([A-Z0-9\-\/]+)/i,
      
      // 2. Looks for "Invoice No.", allows up to 80 characters of scattered text, 
      /(?:Invoice\s*(?:Number|No\.?|#))[\s\S]{0,80}?(INV-[A-Z0-9\-\/]+|\b[A-Z0-9\-\/]*\d+[A-Z0-9\-\/]*\b)/i,
      
      // 3. Fallback: Captures anything starting with "INV-" anywhere in the document
      /(INV-[A-Z0-9\-\/]+)/i
    ];

    let detected = null;

    for (const regex of regexes) {
      const match = fullText.match(regex);
      
      if (match && match[1]) {
        detected = match[1].trim();
        break;
      }
    }

    if (detected) {
      if (!detected.toUpperCase().startsWith('INV-') && fullText.toUpperCase().includes('INV-' + detected.toUpperCase())) {
         detected = 'INV-' + detected;
      }
      
      return detected;
    }
    
    return null;
  } catch (error) {
    console.error('Failed to parse file for invoice number', error);
    return null;
  } finally {
    if (onStatusChange) {
      onStatusChange(false);
    }
  }
};